import * as instrumentation from '@bingads-webui-campaign-legacy/instrumentation/index';
import { getDataSource } from '@bingads-webui-campaign/ad-groups-data';

export function fetchDataForAdGroups({
  resolve,
  queryParam,
  preferenceService,
}) {
  const {
    uid, cid, aid, campaignId,
  } = queryParam.values;
  const scope = {
    values: {
      uid, cid, aid, campaignId,
    },
  };

  instrumentation.default.addScenario({
    scenario: [
      {
        name: 'adGroupsGridDataPrefetch',
        value: 'AdGroupsGridDataPrefetch',
        activity: [
          {
            name: 'dataQueryBuilder',
            value: 'DataQueryBuilder',
          },
        ],
      },
    ],
  });

  const logActivity = instrumentation
    .default
    .adGroupsGridDataPrefetch
    .create()
    .dataQueryBuilder
    .create();

  const tempDataSource = getDataSource({
    scope,
    logActivity,
    preferenceService,
  });

  const { dataSource } = tempDataSource;

  const p$dfm = dataSource.query({}, {}, resolve, true);

  return { dataSource, p$dfm };
}
